import type { ValidationReport } from '../../types/validation';

interface Props {
  validation: ValidationReport | null | undefined;
}

export default function NodeValidationPanel({ validation }: Props) {
  const issues = validation?.issues ?? [];
  if (issues.length === 0) return null;

  return (
    <section className="space-y-2 rounded-lg border border-border bg-surface/40 p-4">
      <h3 className="panel-section-title">Validation</h3>
      <ul className="space-y-2">
        {issues.map((issue, index) => (
          <li
            key={`${issue.code}-${index}`}
            className={`rounded-md px-3 py-2 text-sm ${
              issue.severity === 'error'
                ? 'alert-danger'
                : 'rounded-lg border border-amber-500/25 bg-warning-muted/40 text-warning-on-dark'
            }`}
          >
            {issue.message}
          </li>
        ))}
      </ul>
    </section>
  );
}
